import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 90000,
});

export async function generateBrief({ target_company, user_product }) {
  const { data } = await api.post("/briefs/generate", { target_company, user_product });
  return data;
}

export async function fetchBrief(id) {
  const { data } = await api.get(`/briefs/${id}`);
  return data;
}
